import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeSkeletonModule } from 'se-fe-skeleton'
import { SeFeTimelineSkeletonComponent } from 'se-fe-timeline/skeleton'

@Component({
  selector: 'se-po-profile-roster-history-skeleton',
  standalone: true,
  imports: [SeFeCardModule, SeFeCardHeaderSkeletonComponent, SeFeSkeletonModule, SeFeTimelineSkeletonComponent],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton seFeDataSize="section" [seFeDataHeavyBorder]="true" [seFeDataTitle]="true"></se-fe-card-header-skeleton>
      <se-fe-card-content>
        <se-fe-timeline-skeleton>
          @for (_ of rows; track $index) {
            <div class="roster-timeline-action">
              <div>
                <span seFeSkeleton="text|short"></span>
                <span seFeSkeleton="text|min"></span>
              </div>
              <div>
                <span seFeSkeleton="text|long"></span>
                <span seFeSkeleton="text|medium"></span>
              </div>
              <div>
                <span seFeSkeleton="text|medium"></span>
                <span seFeSkeleton="text|short"></span>
              </div>
            </div>
          }
        </se-fe-timeline-skeleton>
      </se-fe-card-content>
    </se-fe-card>
  `,
  styleUrls: ['./profile-roster-history-skeleton.component.scss'],
})
export class ProfileRosterHistorySkeletonComponent {
  public rows = Array.from({ length: 3 })
}
